import React, { useCallback, useEffect, useState } from 'react';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';
import { ConversionListType } from 'models/pricing.model';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { debounce } from 'utils/functions';

type Props = {
  index: number;
  ingredient_name: string;
  handleChange: (e: { name: string; value: string; rest?: any }, index: number) => void;
};
const MealSelect = ({ index, handleChange, ingredient_name }: Props) => {
  const [search, setSearch] = useState('');
  const [meals, setMeals] = useState<ConversionListType[]>([]);

  const fetchIngredients = async (searchString: string) => {
    try {
      const response = await apiService.get(`ingredient-mix`, {
        params: { type: 'meal', name: searchString, page: 1 },
        version: 'v2'
      });
      if (response) {
        setMeals(
          response?.data?.data?.map((_: any) => ({
            ..._,
            name: _?.ingredient?.name,
            id: _?.id
          }))
        );
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error fetching vendors'}
          type='error'
        />
      );
    } finally {
      // setSearch('');
    }
  };

  const debounceFetchIngredients = useCallback(debounce(fetchIngredients, 500), []);

  useEffect(() => {
    debounceFetchIngredients(search);
  }, [search]);
  return (
    <SelectDropdown
      hasSearch
      label='Meal'
      placeholder='Search meals'
      value={ingredient_name}
      setValue={(item) => {
        handleChange(
          {
            name: 'ingredient_id',
            value: item?.ingredient?.id,
            rest: item
          },
          index
        );
      }}
      onChange={(val) => {
        setSearch(val);
      }}
      options={meals}
    />
  );
};
export default MealSelect;
